import { render, staticRenderFns } from "./IntercomBubble.vue?vue&type=template&id=28b0b340&scoped=true&"
import script from "./IntercomBubble.vue?vue&type=script&lang=js&"
export * from "./IntercomBubble.vue?vue&type=script&lang=js&"
import style0 from "./IntercomBubble.vue?vue&type=style&index=0&id=28b0b340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b0b340",
  null
  
)

export default component.exports